import { PublicClip } from '@air/api';
import { Clip, ClipStatus } from '@air/api/types';
import { ClipUtils } from '@air/utils-clips';
import { useQuery } from '@tanstack/react-query';

export const STATUS_UPDATER = 'STATUS_UPDATER';

export const getClipStatusUpdaterKey = (clipId: Clip['id']) => [STATUS_UPDATER, { clipId }];

export interface UseClipStatusUpdaterParams {
  id: Clip['id'];
  status?: ClipStatus;
  fileSize: number;
  fetchDetails: (itemId: Clip['id']) => Promise<PublicClip | null>;
}

export const useClipStatusChecker = ({
  status = ClipStatus.created,
  id,
  fileSize,
  fetchDetails,
}: UseClipStatusUpdaterParams) => {
  const shouldCheckStatus =
    ClipUtils.isProcessing(status) && !ClipUtils.isNonTranscodable(status) && !ClipUtils.isFailed(status);

  return useQuery({
    queryKey: getClipStatusUpdaterKey(id),
    queryFn: () => fetchDetails(id),
    enabled: shouldCheckStatus,
    refetchInterval: Math.max(3000, fileSize / 1000),
  });
};
